// extracted by mini-css-extract-plugin
export default {"root":"AppLoader_root__d9YUa","loader":"AppLoader_loader__kcmyQ","logo":"AppLoader_logo__Lgt2s","CircularProgress":"AppLoader_CircularProgress__ynSs6"};